import React, { useEffect } from "react";
import { connect } from "react-redux";
import { getUsers, revokeUser } from "../../../redux/Actions/UsersActions";
import DeleteModal from "../../Modal/DeleteModal";

const ActivateWhispaDoctor = (props) => {
  const { revokeUser, isRevoking, id, revokeSuccess, getUsers } = props;

  useEffect(
    () => {
      if (revokeSuccess) {
        props.closeModal();
        getUsers(1, 10, "doctor");
      }
    }, // eslint-disable-next-line
    [revokeSuccess]
  );

  return (
    <DeleteModal
      displayModal={props.displayModal}
      closeModal={props.closeModal}
      title={"Activate this whispa doctor?"}
      width={"463px"}
      text={"Activate"}
      onClick={() => revokeUser(id, "active")}
      disabled={isRevoking}
      isLoading={isRevoking}
      activate={true}
      loadingText={"Activating..."}
      children={
        "Once you activate this whispa doctor, this whispa doctor would be active. Activate whispa doctor?"
      }
    />
  );
};

const mapStateToProps = (state) => ({
  isRevoking: state.users.isRevoking,
  revokeSuccess: state.users.revokeSuccess,
});

const mapDispatchToProps = (dispatch) => ({
  revokeUser: (payload, status) => dispatch(revokeUser(payload, status)),
  getUsers: (page, limit, type) => dispatch(getUsers(page, limit, type)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ActivateWhispaDoctor);
